import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

export const collection = 'workflowTemplates'

export const schema = new schemas.Array(new schemas.Entity(collection))

type FetchQueryType = {
  language: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ language }: FetchQueryType) =>
    callApi(
      `${apiBase}/templates?category=examples_${language.split('_')[0]}`,
      schema
    )
